import { DetailsValueTableData } from '../details-value-table-data/details-value-table-data';
import { CsprAmount } from '../cspr-amount/cspr-amount';
import React from 'react';
import Big from 'big.js';
import { motesToCurrency, PrecisionCase } from '../../utils/currency';
import FiatCurrency from '../multi-currency/multi-currency';
import {
  DEFAULT_AMOUNT_PRECISION,
  SMALL_PRECISION,
  Text,
} from '@make-software/cspr-design';

export interface DetailsBalanceTableDataProps {
  loading: boolean;
  motes: string | number | undefined | null;
  errorMessage?: string | null;
  currencyRate: number | undefined;
  accountEmpty?: boolean;
  isTotalBalance?: boolean;
}

export function DetailsCsprAmountTableData({
  loading,
  motes,
  errorMessage,
  currencyRate,
  accountEmpty,
  isTotalBalance,
}: DetailsBalanceTableDataProps) {
  const emptyBalance =
    accountEmpty ||
    (!loading && (motes === undefined || motes === null || Big(motes).eq('0')));

  if (!emptyBalance && errorMessage) {
    return (
      <DetailsValueTableData
        align="left"
        monotype
        loading={loading}
        colSpan={2}
      >
        {errorMessage}
      </DetailsValueTableData>
    );
  }

  if (emptyBalance) {
    return (
      <>
        <DetailsValueTableData
          align="right"
          monotype
          noWrap
          style={{ width: '1%' }}
        >
          <CsprAmount motes={'0'} precisionCase={PrecisionCase.deployCost} />
        </DetailsValueTableData>
        <DetailsValueTableData
          align="left"
          monotype
          noWrap
          style={{ width: '99%' }}
        >
          <Text variation="darkGray">
            (
            <FiatCurrency
              amount={'0'}
              precision={
                isTotalBalance ? SMALL_PRECISION : DEFAULT_AMOUNT_PRECISION
              }
            />
            )
          </Text>
        </DetailsValueTableData>
      </>
    );
  }

  const MAX_CSPR_AMOUNT_MOTES = '9999999990000000';
  const shouldHidePrecision = Big(motes || '0').gte(MAX_CSPR_AMOUNT_MOTES);

  const precisionCase = shouldHidePrecision
    ? PrecisionCase.none
    : PrecisionCase.small;

  return (
    <>
      <DetailsValueTableData
        align="right"
        monotype
        loading={loading}
        noWrap
        style={{ width: '1%' }}
      >
        <CsprAmount
          motes={motes}
          precisionCase={
            isTotalBalance ? precisionCase : PrecisionCase.deployCost
          }
        />
      </DetailsValueTableData>
      <DetailsValueTableData
        align="left"
        monotype
        loading={loading}
        noWrap
        style={{ width: '99%' }}
      >
        {motes == null || currencyRate == null ? (
          <Text variation="darkGray"> {'(N/A)'}</Text>
        ) : (
          <Text variation="darkGray">
            (
            <FiatCurrency
              amount={motesToCurrency(motes.toString(), currencyRate)}
              precision={
                isTotalBalance ? SMALL_PRECISION : DEFAULT_AMOUNT_PRECISION
              }
            />
            )
          </Text>
        )}
      </DetailsValueTableData>
    </>
  );
}
